import { connect } from 'react-redux';

import { verifyIsMaintenance } from '../../actions/userActions';
import Maintenance from '../../components/Maintenance/Maintenance';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  verifyIsMaintenance: () => dispatch(verifyIsMaintenance()),
});

const MaintenanceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Maintenance);

export default MaintenanceContainer;
